import React, { useState } from 'react';
import transactionStore from '../stores/transaction';
import { Select } from '@/../components/Fields';
import {v4 as uuid} from 'uuid'

export default (params) => {
  const [transactionToEdit, setTransactionToEdit] = transactionStore(state => [state.transactionToEdit, state.setTransactionToEdit])
  const [id] = useState(uuid())
  if (transactionToEdit?.purchase_order_id) return
  return (
    <Select
      name={`direction-select-${id}`}
      value={transactionToEdit?.direction ?? ''}
      onChange={e => setTransactionToEdit({...transactionToEdit, direction: e.target.value})}
      {...params}
    >
      <option value="1">Receive</option>
      <option value="-1">Ship</option>
      <option value="0">Purchase</option>
      <option value="-2">Transfer</option>
      <option value="2">Adjustment</option>
    </Select>
  )
}
